import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top whenever the pathname changes
    // Use multiple methods to ensure it works on all devices
    
    // Method 1: Standard window scroll
    window.scrollTo(0, 0);
    
    // Method 2: Document element scroll (for some mobile browsers)
    if (document.documentElement) {
      document.documentElement.scrollTop = 0;
    }
    
    // Method 3: Body scroll (fallback)
    if (document.body) {
      document.body.scrollTop = 0;
    }
    
    // Method 4: Find the main scrollable container (for iOS)
    const scrollableElements = [
      document.getElementById('root'),
      document.querySelector('.tab-content'),
      document.querySelector('main'),
      document.querySelector('.ios-tab-layout')
    ];
    
    scrollableElements.forEach(element => {
      if (element) {
        element.scrollTop = 0;
      }
    });
    
    // Method 5: For iOS specifically, also try scrolling the first scrollable parent
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (isIOS) {
      // Small delay to ensure the DOM is ready
      setTimeout(() => {
        window.scrollTo(0, 0);
        
        // Also try to find and scroll any scrollable containers
        const allElements = document.querySelectorAll('*');
        allElements.forEach(element => {
          const style = window.getComputedStyle(element);
          if (style.overflowY === 'auto' || style.overflowY === 'scroll') {
            (element as HTMLElement).scrollTop = 0;
          }
        });
      }, 0);
    }
  }, [pathname]);

  return null;
};